// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__6cseU","detailsBorder":"styles_detailsBorder__1fAvK"};